import { Chip } from "@mui/material";

/**
 * Environment Flag Component
 * Displays a chip indicating the current environment (Local, Current, PreProd)
 * Hidden in production environments
 **/

const EnvironmentFlag = () => {
  const envName = import.meta.env.VITE_ENV_NAME;
  // Don't render anything in production
  if (!envName || envName === "Production") {
    return null;
  }

  return (
    <Chip
      label={`${envName} Env.`}
      color="info"
      size="small"
      variant="outlined"
      sx={{
        fontWeight: 500,
        marginLeft: 1,
      }}
    />
  );
};

export default EnvironmentFlag;
